

export const codes = {
	metaInfo: {
		title: 'delimall'
		,copyright: 'Delimall'
	}
	, task_status: {
		'report_status_wait': 0 // 작업 대기
		,'report_status_begin': 1 // 작업 시작
		,'report_status_complete': 2 // 작업 완료
		,'report_status_confirm': 3 // 1차 승인
		,'report_status_return': 4 // 1차 승인 반려
		,'report_status_try': 5 // 1차 재승인 요청
		,'report_status_confirm_last': 6 // 최종 승인
		,'report_status_return_last': 7 // 최종 승인 반려
		,'report_status_try_last': 8 // 최종 재승인 요청
	}
}
